import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';
import * as apiClient from "../../services/apiClient";
import { getUserLogged } from "../../services/loginClient";

const Sidebar = ({ onLoad }) => {
    const { t } = useTranslation();

    const [menuElemnts, setMenuElements] = useState([]);
    const [translations, setTranslations] = useState([]);
    const [userLogged, setUserLogged] = useState(getUserLogged());

    useEffect(() => {
        const GetMenu = async () => {
            const data = await apiClient.GetMenu(userLogged.token);
            setMenuElements(data.elementoMenu);
        }

        const FetchTranslations = async () => {
            const language = navigator.language.startsWith('es') ? 'es' : 'en';
            const labels = await apiClient.GetLabelsByController(language, "Menu");
            const data = await apiClient.GetTranslationsByLabels(language, labels);
            setTranslations(data);
        };

        const GetPermissions = async () => {

        };

        GetMenu();
        FetchTranslations();

        setTimeout(() => {
            onLoad();
        }, 2000);
    }, []);

    const getTranslation = (label) => {
        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const handleSidebarToggle = (collapsed) => {
        const logo = document.getElementById('img-ayesa-sidebar');
        const brandLink = document.getElementById('brand-link');

        if (collapsed) {
            logo.src = "dist/img/logo-ayesa-correo.png";
            logo.classList.add('small-logo');
            brandLink.classList.add('collapsed');
        }
        else {
            logo.src = "dist/img/logo-ayesa.png";
            logo.classList.remove('small-logo');
            brandLink.classList.remove('collapsed');
        }
    };

    const handleMouseEnter = () => {
        if (document.body.classList.contains('sidebar-mini') && document.body.classList.contains('sidebar-collapse')) {
            handleSidebarToggle(false);
        }
    };

    const handleMouseLeave = () => {
        if (document.body.classList.contains('sidebar-mini') && document.body.classList.contains('sidebar-collapse')) {
            handleSidebarToggle(true);
        }
    };

    const renderMenu = (menu) => {
        return menu.map((item) => {
            if (item.children.length > 0) {
                return (
                    <li className="nav-item">
                        <NavLink to="/index.html" className="nav-link" onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            
                            if ($(event.target).closest('li').hasClass('menu-open')) {
                                $(event.target).closest('li').removeClass('menu-is-opening').removeClass('menu-open')
                            } else {
                                $(event.target).closest('li').addClass('menu-is-opening').addClass('menu-open')
                            }
                        }}>
                            {(null != item.icono) && (
                                <img src={item.icono} alt={getTranslation(item.etiqueta)} className="nav-icon" />
                            )}
                            
                            <p>
                                {getTranslation(item.etiqueta)}
                                <i className="right fas fa-angle-left" />
                            </p>
                        </NavLink>
                        <ul className="nav nav-treeview">
                            {renderMenu(item.children)}
                        </ul>
                    </li>
                );
            } else if (item.idOpcionPadre === 0 && item.agrupador) {
                return (
                    <li className="nav-item">
                        <NavLink to={item.accion} className="nav-link">
                            {(null != item.icono) && (
                                <img src={item.icono} alt={getTranslation(item.etiqueta)} className="nav-icon" />
                            )}
                            <p>
                                {getTranslation(item.etiqueta)}
                            </p>
                        </NavLink>
                    </li>
                );
            } else {
                return (

                    <li className="nav-item">
                        <NavLink to={item.accion} className="nav-link" style={{marginLeft: '20px'}}>
                            {getTranslation(item.etiqueta)}
                        </NavLink>
                    </li>

                );
            }
        });
    };

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    handleSidebarToggle(document.body.classList.contains('sidebar-collapse'));
                }
            });
        });

        observer.observe(document.body, { attributes: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div>
            {/* Main Sidebar Container */}
            <aside id="sidebar-css" className="main-sidebar sidebar-dark-primary elevation-4" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                {/* Brand Logo */}
                <NavLink to="/" className="brand-link" id="brand-link" exact>
                    <img src="dist/img/logo-ayesa" className="img-ayesa-sidebar" id="img-ayesa-sidebar" />
                    <span className="brand-text font-weight-light"></span>
                </NavLink>
                {/* Sidebar */}
                <div className="sidebar">
                    {/* Sidebar Menu */}
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column nav-collapse-hide-child nav-child-indent nav-legacy" data-widget="treeview" role="menu" data-accordion="false">
                            {
                                renderMenu(menuElemnts)
                            }
                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    )
}

export default Sidebar;